export const S3KeyTypes: Record<string, string> = {
	OBJECT: "OBJECT",
	USER_OBJECT: "USER_OBJECT",
	SCOPE_USER_OBJECT: "SCOPE_USER_OBJECT",
};

export const S3Scopes: Record<string, string> = {
	PRIVATE: "private",
};
